import { IQuery } from 'types';

export const urlParamsToObject = (
  iterator: URLSearchParams
): {
  [key: string]: string;
} => {
  const arrayIterator = Array.from(iterator.entries());
  const params: { [key: string]: string } = {};
  for (const [key, value] of arrayIterator) {
    params[key] = value;
  }
  return params;
};

export const queryBuilder = <T extends Record<string, any>>(params: T): string => {
  const queryParts: string[] = [];

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null && v !== "")
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
      });
    } 

    else if (value instanceof Date) {
      queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString())}`);
    } 
    
    else {
      queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });

  return queryParts.length ? `?${queryParts.join("&")}` : "";
};

